<template>
	<div>
	 <header-nav :cur="5"/>
	 <div class="nav">
	     <div class="navtab">
	         <span class="top">
	              <span @click="toIndex()" style="cursor:pointer"  >首页</span>&nbsp;>
	             <span class="infor">证书</span>
	         </span>
	         <div class="newbox">
	             <div>
	                 <div class="newtop">查询证书通道</div>
	                 <div class="newbot">根据2025年度甘肃省人力资源和社会保障厅相关文件要求查询</div>
	             </div>
	            <!-- <div class="input">
	                 <input placeholder="请输入您想要寻找的课程" type="text"   v-model="queryParams.courseName"/>
	                 <div class="select" @click="getList()">搜索</div>
	             </div> -->
	         </div>
	     </div>
	 </div>
	  <div class="certificate-guide-container">
		<el-card class="guide-card" shadow="hover">
		  <div class="header-section">
			<h1 class="title">专业技术人员继续教育学分证书申请查看操作说明(附操作视频)</h1>
			<div class="divider">
			  <el-divider><i class="el-icon-document"><a href="https://rst.gansu.gov.cn/rst/c113673/202504/174120354/files/cb30993ea6164cfa822fac870973087a.pdf"></a></i></el-divider>
			</div>
		  </div>
		  
		  <div class="content-section">
			<div class="process-section">
			  <h2 class="sub-title">获取学分证书简易流程</h2>
			  <el-steps :active="5" align-center>
				<el-step title="证书申请" description="进入本平台个人中心证书管理页面内提交证书申请"></el-step>
				<el-step title="登录平台" description="进入甘肃省政务服务网统一登录"></el-step>
				<el-step title="选择服务" description="选择【个人办事】-【人事人才】"></el-step>
				<el-step title="证书查询" description="学时认定证书查询-【在线办理】"></el-step>
				<el-step title="选择年度" description="选择相应年度查询"></el-step>
				<el-step title="下载证书" description="获取您的继续教育证书"></el-step>
			  </el-steps>
			</div>
			
			<div class="notice-section">
			  <el-alert title="重要通知" type="warning" :closable="false">
				<p>根据2025年度甘肃省人力资源和社会保障厅相关文件要求：</p>
				<p>1. 学员培训合格后，培训证书由甘肃人社公共服务平台统一发放并提供查询下载</p>
				<p>2. 原甘肃省专业技术人员继续教育工作平台暂停使用</p>
				<p>3. 往年证书需到新平台下载</p>
				<p>4. 每周五18:00，系统管理员会把本周内证书申请信息打包提交到证书系统(请即使关注证书状态)</p>
			  </el-alert>
			</div>
			
			<div class="action-section">
			  <el-button 
				type="primary" 
				icon="el-icon-link" 
				size="large"
				@click="goToPlatform"
			  >
				进入甘肃人社公共服务平台获取证书
			  </el-button>
			  
			  <el-button 
				type="success" 
				icon="el-icon-video-play" 
				size="large"
				@click="showVideo"
			  >
				点击查看视频教程
			  </el-button>
			</div>
		  </div>
		</el-card>
		
		<!-- 视频弹窗 -->
		<el-dialog title="操作视频教程" :visible.sync="videoVisible" width="70%">
		  <div class="video-container">
			<!-- 这里放置视频嵌入代码 -->
			<p style="text-align: center; padding: 50px 0; background: #f5f7fa; border-radius: 4px;">
			  <i class="el-icon-video-play" style="font-size: 48px; color: #409EFF;"></i>
			  <br>
			  这里是操作视频教程内容
			</p>
		  </div>
		</el-dialog>
	  </div>
	  
	  <!-- 底部 -->
	  <footer-nav style="padding-top: 80px;" />
	</div>
	
</template>

<script>
	
  import headerNav from '../../components/HeaderNav.vue';
  import footerNav from '../../components/FooterBar';
  export default {
	components: {
		headerNav,
		footerNav,
	//QuillEditor,
	},
	name: 'CertificateGuide',
	data() {
		return {
		  videoVisible: false
		}
	},
	methods: {
		goToPlatform() {
		  // 跳转到平台的实际代码
		  window.open('https://wsbs.rst.gansu.gov.cn/publicservice/home', '_blank');
		},
		showVideo() {
		  window.open('https://jxjypt.luas.edu.cn/api/profile/upload/2024/zscxsp.mp4', '_blank')
		}
	}
  }
</script>

<style scoped>
	
	.navtab {
	  width: 1280px;
	  margin: 0 auto;
	}
	
	.color {
	  color: #2961EF !important;
	}
	
	.ignore {
	  overflow: hidden;
	  text-overflow: ellipsis;
	  display: -webkit-box;
	  -webkit-box-orient: vertical;
	  -webkit-line-clamp: 3;
	}
	
	.nav {
	    background: #f7f8fa;
	    width: 100%;
	    height: 177px;
	    .top {
	        display: block;
	        font-size: 16px;
	
	        font-weight: 300;
	        color: #777777;
	        padding: 19px 0 24px;
	        .infor {
	            color: #2961EF;
	        }
	    }
	    .newbox {
	        display: flex;
	        justify-content: space-between;
	        align-items: center;
	        .newtop {
	            font-size: 26px;
	            color: #000000;
	            margin-bottom: 5px;
	        }
	        .newbot {
	            font-size: 16px;
	            color: #888888;
	        }
	        .input {
	            width: 497px;
	            height: 59px;
	            background: #ffffff;
	            box-shadow: 3px 3px 10px 1px rgba(11, 19, 72, 0.050980392156862744);
	            border-radius: 30px;
	            position: relative;
	            input {
	                border: none;
	                position: absolute;
	                left: 30px;
	                top: 0;
	                height: 59px;
	                line-height: 59px;
	                width: 365px;
	                font-size: 16px;
	
	                font-weight: 300;
	                color: #777777;
	            }
	            .select {
	                position: absolute;
	                right: 12px;
	                top: 8px;
	                width: 74px;
	                height: 43px;
	                line-height: 43px;
	                background: #2961EF;
	                border-radius: 30px;
	                font-size: 16px;
	
	                font-weight: 300;
	                color: #ffffff;
	                text-align: center;
	            }
	        }
	    }
	}
	.certificate-guide-container {
	  max-width: 1200px;
	  margin: 0 auto;
	  padding: 20px;
	}

	.guide-card {
	  border-radius: 8px;
	  border: none;
	}

	.header-section {
	  text-align: center;
	  margin-bottom: 30px;
	}

	.title {
	  color: #303133;
	  font-size: 28px;
	  margin-bottom: 0;
	}

	.divider {
	  margin: 10px auto;
	  max-width: 600px;
	}

	.sub-title {
	  color: #409EFF;
	  text-align: center;
	  margin: 30px 0;
	  font-size: 22px;
	}

	.process-section {
	  margin-bottom: 40px;
	}

	.notice-section {
	  margin: 30px 0;
	}

	.notice-section p {
	  margin: 8px 0;
	  line-height: 1.6;
	}

	.action-section {
	  text-align: center;
	  margin: 40px 0 20px;
	}

	.action-section .el-button {
	  margin: 0 15px;
	  padding: 15px 25px;
	  font-size: 16px;
	}

	.video-container {
	  position: relative;
	  padding-bottom: 56.25%; /* 16:9 */
	  height: 0;
	  overflow: hidden;
	}

	@media (max-width: 768px) {
	  .title {
		font-size: 22px;
	  }
	  
	  .action-section .el-button {
		display: block;
		width: 100%;
		margin: 10px 0;
	  }
	}
</style>